export default "ALTER TABLE `reservas` ADD `is_emergency_fund` integer DEFAULT 0 NOT NULL;";